import React from 'react';
import styles from './Tooltip.module.css';
import Image from 'next/image';

interface TooltipProps {
  tooltipText: string;
  style?: React.CSSProperties;
}

const Tooltip: React.FC<TooltipProps> = ({ tooltipText, style }) => {
  return (
    <div className={styles.tooltipContainer} style={style}>
      <Image
        src="/icons/ToolTipPng.png"
        alt="Tooltip Icon"
        className={styles.icon}
        width={12}
        height={12}
      />
      <div className={styles.tooltipText}>{tooltipText}</div>
    </div>
  );
};

export default Tooltip;
